var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"pdf"}}),_c('div',{staticClass:"remind"},[_vm._v("长按下载图片保存/转发")])])}]

export { render, staticRenderFns }